export { Microdata } from './microdata.component';
